import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureMySqlCopySource } from 'app/model/pipeline/copysource/azure-mysql.copysource';
import moment from 'moment-timezone';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureMySqlCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        queryCommandTimeout: '*',
        queryTimeout: '*'
    }
})
export class AzureMySqlCopySourceAdapter extends CopySourceAdapter<AzureMySqlCopySource, Model.AzureMySqlSource> {
    protected override async _toResource(copySource: AzureMySqlCopySource): Promise<Model.AzureMySqlSource> {
        const result: Model.AzureMySqlSource = this.getCommonCopySourceProperties(copySource, 'AzureMySqlSource');
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, AzureMySqlCopySource.READER_QUERY);
        }
        try {
            result.queryTimeout =
                typeof copySource.queryTimeout === 'number'
                    ? moment.duration(copySource.queryTimeout, 'minutes').format('hh:mm:ss', {
                          trim: false
                      })
                    : ValueAdapter.toResource(copySource, AzureMySqlCopySource.QUERY_TIMEOUT);
        } catch {
            this._logError('Failed to convert queryTimeout into TimeSpan');
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.AzureMySqlSource,
        copyActivity: CopyActivity
    ): Promise<AzureMySqlCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureMySqlCopySource.MODEL,
            resource,
            copyActivity
        ) as AzureMySqlCopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, AzureMySqlCopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        try {
            if (resource.queryCommandTimeout == null && resource.queryTimeout == null) {
                result.queryTimeout = undefined;
            } else if (resource.queryCommandTimeout != null) {
                if (
                    typeof resource.queryCommandTimeout === 'string' &&
                    !isLogicAppExpression(resource.queryCommandTimeout)
                ) {
                    result.queryTimeout = moment.duration(resource.queryCommandTimeout).asMinutes();
                } else {
                    ValueAdapter.toModel(result, AzureMySqlCopySource.QUERY_TIMEOUT, resource.queryCommandTimeout);
                }
            } else {
                if (typeof resource.queryTimeout === 'string' && !isLogicAppExpression(resource.queryTimeout)) {
                    result.queryTimeout = moment.duration(resource.queryTimeout).asMinutes();
                } else {
                    ValueAdapter.toModel(result, AzureMySqlCopySource.QUERY_TIMEOUT, resource.queryTimeout);
                }
            }
        } catch {
            this._logError('Failed to convert queryCommandTimeout into number');
        }
        return result;
    }
}
